<template>
  <div class="question_index">
    <div class="question_user">
      <div class="u-ft">1.初诊日期</div>
      <div class="question_field">
        <!-- <van-field name="calendar" v-model="data" placeholder="请输入"   @click="showCalendar = true"/> -->
        <van-field
          readonly
          clickable
          name="calendar"
          :value="firstDate"
          placeholder="点击选择日期"
          @click="showCalendar = true"
        />
        <van-calendar
          v-model="showCalendar"
          :min-date="minDate"
          @confirm="onConfirm"
          color="#208FE3"
        />
      </div>
      <div class="u-ft">2.姓名</div>
      <div class="question_field">
        <van-field v-model="patientName" placeholder="请输入" />
      </div>
      <div class="u-ft">3.处方次数</div>
      <div class="question_field">
        <van-field v-model="prescriptionNum" placeholder="请输入" />
      </div>
      <div class="u-ft">4.性别</div>
      <div class="question_radio">
        <van-radio-group v-model="patientSex" direction="horizontal">
          <van-radio name="男">男</van-radio>
          <van-radio name="女">女</van-radio>
        </van-radio-group>
      </div>
      <div class="u-ft">5.联系方式</div>
      <div class="question_field">
        <van-field v-model="patientMobile" placeholder="请输入" />
      </div>
      <div class="u-ft">6.病种</div>
      <div class="question_field">
        <van-field v-model="diseaseType" placeholder="请输入" />
      </div>
      <div class="u-ft">7.责任医生</div>
      <div class="question_field">
        <van-field v-model="doctorName" placeholder="请输入" />
      </div>
      <div class="u-ft">8.线下 | 线下</div>
      <div class="question_field1">
        <!-- <van-field v-model="offlineOne" placeholder="请输入" /> -->
        <van-radio-group v-model="offlineOne" direction="horizontal">
          <van-radio name="1">线上</van-radio>
          <van-radio name="2">线下</van-radio>
        </van-radio-group>
      </div>
      <div class="u-ft">9.处方周期</div>
      <div class="question_field">
        <van-field type="number" v-model="prescriptionCycleOne" placeholder="请输入">
          <template #button>
            天
          </template>
        </van-field>
      </div>
      <div class="u-ft">10.病情回访</div>
      <div class="question_field">
        <van-field v-model="diseaseFollowOne" placeholder="请输入" />
      </div>

      <van-button class="qustionIndex_Submit" color="#208fe3" size="large" @click="save"
        >提交</van-button
      >
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import { Dialog, Button, Popup as VanPopup } from 'vant';
import { Field, CellGroup } from 'vant';
import sale from '../services/saleLogin';
import { Toast as VanToast } from 'vant';
import { Calendar } from 'vant';
Vue.use(Calendar);

import { RadioGroup, Radio } from 'vant';
Vue.use(Radio);
Vue.use(RadioGroup);
export default {
  name: 'patientManagement',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    Button,
    VanPopup,
    [Field.name]: Field,
    [CellGroup.name]: Field,
    VanToast
  },
  data() {
    return {
      id: this.$route.params.id,
      minDate: new Date(2010, 0, 1),
      saleId: undefined,
      patientName: '',
      patientMobile: '',
      showCalendar: false,
      firstDate: undefined,
      patientSex: '男',
      prescriptionNum: undefined,
      diseaseType: undefined,
      doctorName: undefined,
      offlineOne: '1',
      prescriptionCycleOne: undefined,
      onlineOne: undefined,
      prescriptionCycleTwo: undefined,
      diseaseFollowOne: undefined,
      offlineTwo: undefined,
      onlineTwo: undefined,
      prescriptionCycleThree: undefined,
      prescriptionCycleFour: undefined,
      diseaseFollowTwo: undefined
    };
  },

  created() {},
  methods: {
    onConfirm(date) {
      this.firstDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      this.showCalendar = false;
    },

    save() {
      if (this.patientName == '') {
        VanToast.fail('请填写患者姓名');
      } else if (this.patientMobile == '') {
        VanToast.fail('请填写手机号码');
      } else if (this.doctorName == undefined) {
        VanToast.fail('请填写责任医生');
      } else {
        const params = {
          saleId: this.$route.params.saleId,
          firstDate: this.firstDate,
          prescriptionNum: this.prescriptionNum,
          patientName: this.patientName,
          patientSex: this.patientSex,
          patientMobile: this.patientMobile,
          diseaseType: this.diseaseType,
          doctorName: this.doctorName,
          offlineOne: this.offlineOne,
          prescriptionCycleOne: this.prescriptionCycleOne,
          onlineOne: this.onlineOne,
          prescriptionCycleTwo: this.prescriptionCycleTwo,
          diseaseFollowOne: this.diseaseFollowOne,
          offlineTwo: this.offlineTwo,
          prescriptionCycleThree: this.prescriptionCycleThree,
          onlineTwo: this.onlineTwo,
          prescriptionCycleFour: this.prescriptionCycleFour,
          diseaseFollowTwo: this.diseaseFollowTwo
        };
        sale.save(params).then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            VanToast.success('保存成功');
            this.$router.push({
              path: `/patientManagementList/${this.$route.params.saleId}`
            });
          } else {
            VanToast.success('保存失败，请您核对数据');
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
body {
  width: 100%;
}
.van-button {
  position: fixed;
  bottom: 10%;
  left: 10%;
  z-index: 999;
  width: 80%;
  border-radius: 6px;
  color: #208fe3;
  font-size: 20px;
}
.question_body {
  margin: 0 20px;
  color: #484848;
}
.questionnaireIndex_Title {
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
}
.questionnaireIndex_text {
  margin-top: 5px;
  font-size: 16px;
}
.question_user {
  margin: 30px 20px;
  color: #484848;
  position: relative;
  .u-ft {
    font-size: 18px;

    span {
      position: absolute;
      margin-right: 10px;
      margin-top: -5px;
      font-size: 15px;
      color: red;
      text-align: center;
      box-shadow: 0 0 0 1px #fff;
      border-radius: 10px;
      padding: 0 10px;
    }
  }

  .question_field {
    border: 1px solid #208fe3;
    margin: 10px 0px 30px 0px;
    font-size: 16px;
  }
  .question_radio {
    margin: 10px 0px 20px 0px;
    font-size: 16px;
  }
}
.qustionIndex_Submit {
  position: relative;
  bottom: 0;
  margin-bottom: 100px;
  margin-top: 10px;
}
.question_field1 {
  margin: 10px 0px 30px 0px;
  font-size: 16px;
}
</style>
